import styled from "styled-components";
import { black, grey, scarpaGray500, scarpaGray600 } from "StylesConstants";

export const Container = styled.div`
  .main-title {
    font-family: "Open Sans", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 36px;
    color: ${black};
    margin: 0 0 16px 0;
    text-align: left;
  }

  .price-wrapper {
    margin-bottom: 16px;
  }

  .title-price {
    font-family: "Open Sans", sans-serif;
    font-size: 12px;
    line-height: 16px;
    color: ${scarpaGray500};
    font-weight: 700;
    margin: 0 0 8px 0;
  }

  .price {
    font-family: "Open Sans", sans-serif;
    font-size: 24px;
    line-height: 28px;
    color: ${scarpaGray600};
    margin: 0;
    font-weight: 700;
  }

  .intro {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border-bottom: 1px solid ${grey};
    padding-bottom: 24px;
    margin-bottom: 24px;
    gap: 16px 10px;
  }

  .item-prop {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .icon {
    font-size: 18px;
    color: ${({ $iconColor }) => $iconColor};
  }

  .titulo {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: ${black};
  }
`;
